import React, { useEffect, useState, useRef } from "react";
import * as THREE from "three";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import sphereBackground from "./materials/ParqueEolico0001.jpg";

const ParqueEolico = (props) => {
  const group = useRef(null);
  const backgroundSphere = useTexture(sphereBackground);

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh visible position={[0, 0, 0]} rotation={[0, Math.PI, 0]}>
        <sphereGeometry attach="geometry" args={[30, 32, 32]} />
        <meshBasicMaterial
          attach="material"
          color="white"
          map={backgroundSphere}
          side={THREE.BackSide}
        />
      </mesh>
    </group>
  );
};

export default ParqueEolico;
